module.exports = __webpack_public_path__ + "img/energy.b4c641ca.svg";